<div class="name-container hidden-d-none" [hidden]="!isExpanded || isMobileScreen"
  [attr.aria-hidden]="!isExpanded || isMobileScreen" role="presentation">
  <p class="name mat-body-2 semi-bold text-ellipsis" id="">
    {{ preferredUsername }}
  </p>
</div>

<button type="button" class="btn-icon-40 acct-menu-icon hidden-d-none" [matMenuTriggerFor]="accountMenu"
  aria-label="Open account menu" xPosition="after">
  <mat-icon class="elipses-menu">more_vert</mat-icon>
</button>

<mat-menu #accountMenu="matMenu" class="account-menu menu-dropdown">
  <ng-template matMenuContent>
    <div class="menu-lists" role="presentation">
      <ul>
        <li>
          <button mat-menu-item class="btn-link" type="button" (click)="logoutClickEvent()">
            <mat-icon class="outlined gray md-18">logout</mat-icon>
            <span class="mat-body-2 default">Log out</span>
          </button>
        </li>
      </ul>
    </div>
  </ng-template>
</mat-menu>